// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-XSCa","selected":"styles_selected__1vkv_"};